import { render, staticRenderFns } from "./abastecimentoReport.vue?vue&type=template&id=04eb74d2"
import script from "./abastecimentoReport.vue?vue&type=script&lang=js"
export * from "./abastecimentoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports